<template>
  <div class="example-simple">
    <div v-if="!success.status" class="example-btn">
      <file-upload class="FITFileUpload" :multiple="false" :size="1024 * 1024 * 10" :drop="!this.disabled" v-model="files" @input-filter="inputFilter" @input-file="inputFile" ref="upload">
        <el-row :class="this.disabled?'FITDisabled':''" class="dropDownContainer mx-0 my-2" align-v="center">
          <el-col class="text-center">
            <span v-if="message" class="d-block text-primary remindMsg align-center" :class="this.disabled?'TextDisabled':''">{{message}}</span>
            <span v-else class="d-block text-primary remindMsg align-center" :class="this.disabled?'TextDisabled':''">{{$t('kol.FITFileUpload.dropFileMsg')}}</span>
          </el-col>
        </el-row>
      </file-upload>
    </div>
    <div class="upload py-2 center">
      <div v-if="!success.status">
        <span v-if="files[0]&&showUploadBtn" class="text-danger remindMsg">{{$t('FITFileUpload.uploadRemindMsg')}}</span>
      </div>
      <div v-else>
        <span v-if="files[0]" class="remindMsg text-success font-weight-bold">{{$t('FITFileUpload.successMsg')}}</span>
      </div>
      <table v-if="files[0]" class="my-2 table table-striped table-condensed fixed full-width">
        <thead>
          <tr class="text-center">
            <!-- <th colspan="4" class="text-left">{{$t('fitComponents.FITImageUpload.fileName')}}</th> -->
            <!-- <th colspan="1">{{$t('fitComponents.FITImageUpload.size')}}</th> -->
            <th colspan="1">{{$t('kol.FITFileUpload.preview')}}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(file,index) in files">
            <tr :key="file.id + '-info'" class="text-center ">
              <!-- <td colspan="4" class="text-left align-middle">{{ file.name }}</td> -->
              <!-- <td class="align-middle" colspan="1">{{ file.size | formatSize }}</td> -->
              <!-- <td class="align-middle" colspan="1">
                <i v-if="!success.status" class='px-2 py-2 fa fa-times' @click="removeFile(index)"></i>
                <font-awesome-icon icon="times" v-if="!success.status" @click="removeFile(index)"></font-awesome-icon>
              </td> -->
              <td class="align-middle" colspan="1">
                <img class="preview" style="max-width:300px" v-bind:ref="'image'+parseInt( index )"/>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
<style>
.example-simple label.btn {
  margin-bottom: 0;
  margin-right: 1rem;
}
.preview {
  width:100%;
  height:auto;
}

.align-center{
  height: 90px;
  line-height: 90px;
  text-align: center
}

.center{
  margin: 0 15%;
  width: 70%;
  padding: 10px;
}
.full-width{
  width:100%;
}

</style>
<script>
import FileUpload from 'vue-upload-component'
import API from '@/api/api.js'
import APIList  from '@/api/apiList.js'

export default {
  name: 'FITFileUpload',
  components: {
    FileUpload,
  },
  props: {
    linkedEntity: {
      type: String,
      default: 'L'
    },
    linkedEntityID: {
      type: String,
      default: '10'
    },
    showUploadBtn: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    message:{
      type:String,
    },
    multiple:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      files: [],
      chunkEnabled: false,
      // 1MB by default
      chunkMinSize: 1,
      chunkMaxActive: 3,
      chunkMaxRetries: 5,
      api: new APIList(),
      success: { status: false }
    }
  },
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }

      }
    },
    inputFile(newFile, oldFile) {
      this.$emit("changed",1)
      if (newFile && !oldFile) {
        // add
        // console.log('add', newFile)
        this.$refs.upload.active = true;
      }
      if (newFile && oldFile) {
        // update
        // console.log('update', newFile)
      }
      if (!newFile && oldFile) {
        // remove
      }
      this.getImagePreviews();
    },
    formUploadFiles() {
      // Upload Files with forms
      var files = this.files;
      // console.log(files);
      var data = {};
      data.files = [];
      for (var i = 0; i < files.length; i++) {
        let item = files[i];
        // console.log(item);
        // add file
        data.files.push(item.file);
      };
      // data.append('linkedEntity', this.linkedEntity);
      // data.append('linkedEntityID', this.linkedEntityID);
      console.log(data);
      // this.lockFiles();
      this.$emit('input', data);
    },
    getImagePreviews(){
        /*
          Iterate over all of the files and generate an image preview for each one.
        */
        for( let i = 0; i < this.files.length; i++ ){
          /*
            Ensure the file is an image file
          */
          if ( /\.(jpe?g|png|gif)$/i.test( this.files[i].name ) ) {
            /*
              Create a new FileReader object
            */
            let reader = new FileReader();

            /*
              Add an event listener for when the file has been loaded
              to update the src on the file preview.
            */
            reader.addEventListener("load", function(){
              this.$refs['image'+parseInt( i )][0].src = reader.result;
            }.bind(this), false);

            /*
              Read the data for the file in through the reader. When it has
              been loaded, we listen to the event propagated and set the image
              src to what was loaded from the reader.
            */
           console.log(this.files[i].file)
            reader.readAsDataURL( this.files[i].file );
          }
        }
        },
    removeFile(index) {
      this.files.splice(index, 1);
      if(this.files.length == 0){
        this.$emit("empty",0)
      }
    },
    lockFiles() {
      console.log(this.$refs);
      this.success.status = true;
    },
    unlockFiles() {
      // console.log("unlocked");
      this.success.status = false;
    },
    initialize(){
      this.unlockFiles();
      this.files = [];
    }
  },
}

</script>
<style scoped>
.chunk-loading {
  margin: -12px;
  display: flex;
  width: calc(100% + 24px);
}

.chunk-loading .chunk-loading-part {
  height: 25px;
  line-height: 25px;
  flex: 1;
  background: #ccc;
  font-size: 14px;
  color: white;
  text-align: center;
}

.chunk-loading .chunk-loading-part.chunk-loading-part__uploaded {
  background: #28A745;
}

.uploadFileInput {
  margin: 0px !important;
}

.colspanMaxWidth {
  max-width: 200px;
}

.dropDownContainer {
  background-color: #f1f9ff;
  height: 100px;
  width: 100%;
  border: dotted 1px #ccc;
}

.FITFileUpload {
  width: 100%;
  cursor: pointer;
}

.FITDisabled {
  background-color: rgba(231, 231, 231, 0.3) !important;
}

.TextDisabled {
  color: #999 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/FITImageUpload.vue